import { Component, Fragment } from 'react';
import loadjs from 'loadjs';
import CookieNotice from '@sp/cookie-notice-manager/src/components';
import { utils } from '@sp/cookie-notice-manager';

import { MODAL_ROUTES } from 'constants/routes';
import ModalContainer from 'components/ModalContainer';

import { MainView, ModalView, removeSlashes } from './components';
import {
  GTM_KEY,
  COOKIE_BODY_CLASS,
  POLICY_URL,
  COOKIE_LCZ_STRINGS,
} from './constants';

class App extends Component {
  currentLocation = { ...this.props.location, pathname: '/' };

  componentDidMount() {
    if (utils.isGDPRAnalyticsEnabled()) {
      this.initGTM();
    }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.location.hash) {
      return true;
    }

    if (
      nextProps.location.state &&
      nextProps.location.state !== this.props.location.state
    ) {
      return true;
    }

    if (nextProps.location.pathname === this.props.location.pathname) {
      return false;
    }

    return true;
  }

  setCurrentLocation = () => {
    const { location } = this.props;
    const { pathname } = location;

    const isNotModal = !MODAL_ROUTES.find(route => route === pathname);

    if (isNotModal) {
      this.currentLocation = location;
    }
  };

  handleCookieAccept = ({ ANALYTICS }) => {
    if (ANALYTICS) {
      this.initGTM();
    }
  };

  handleToolbarOpen = () => {
    document.body.classList.add(COOKIE_BODY_CLASS);
  };

  handleToolbarClose = () => {
    document.body.classList.remove(COOKIE_BODY_CLASS);
  };

  initGTM = () => {
    if (this.GTMInited) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    loadjs(`https://www.googletagmanager.com/gtm.js?id=${GTM_KEY}`);
    this.GTMInited = true;
  };

  render() {
    this.setCurrentLocation();
    const { state } = this.currentLocation;
    const error404Condition = state && state.notFoundError;

    return (
      <Fragment>
        <MainView location={this.currentLocation} test={error404Condition} />

        <ModalView
          location={this.props.location}
          parentPath={this.currentLocation.pathname}
        />

        <CookieNotice
          modalContainer={ModalContainer}
          lczStrings={COOKIE_LCZ_STRINGS}
          onAccept={this.handleCookieAccept}
          onOpenToolbar={this.handleToolbarOpen}
          onCloseToolbar={this.handleToolbarClose}
          infoUrl={POLICY_URL}
        />
      </Fragment>
    );
  }
}

export default removeSlashes(App);
